import { scaleLinear, scaleSqrt } from 'd3-scale';
import { max } from 'd3-array';
import { RADIUS_RANGE } from './constants.js';

/**
 * Build x/y/r scales with global domains computed once across all years so
 * points don't jump scale during year transitions. Pixel ranges are set
 * separately by `setRange` whenever the chart is resized.
 */
export function buildScales(prepared) {
  const all = prepared.all;
  const x = scaleLinear().domain([25, 100]);
  const yMax = Math.ceil((max(all, (d) => d.margen_pct) || 50) / 10) * 10;
  const y = scaleLinear().domain([0, yMax]).nice();
  const r = scaleSqrt()
    .domain([0, max(all, (d) => d.censo) || 1])
    .range(RADIUS_RANGE);
  return { x, y, r };
}

export function setRange(scales, innerW, innerH) {
  scales.x.range([0, innerW]);
  scales.y.range([innerH, 0]);
}
